module.exports = __webpack_public_path__ + "img/steel-4.d00ed813.jpg";